import React from "react";
import Icon from "../../shared/Icon";
import { QUIZ_ANSWER_STATES } from "../constants";

const iconName = (state) => {
  switch (state) {
    case QUIZ_ANSWER_STATES.SKIPPED:
    case QUIZ_ANSWER_STATES.CORRECT:
      return "checkmark-64";
    case QUIZ_ANSWER_STATES.INCORRECT:
      return "close-48";
    case QUIZ_ANSWER_STATES.LOCKED:
      return "lock-filled-48";
    case QUIZ_ANSWER_STATES.DISABLED:
    case QUIZ_ANSWER_STATES.UNLOCKED:
    default:
      return "";
  }
};

function QuizAnswerChoiceIcon({ answerLetter, state }) {
  const icon = iconName(state);
  switch (state) {
    case QUIZ_ANSWER_STATES.UNLOCKED:
    case QUIZ_ANSWER_STATES.DISABLED:
      return <div className="button-1 quiz-button">{answerLetter}</div>;
    case QUIZ_ANSWER_STATES.CORRECT:
    case QUIZ_ANSWER_STATES.INCORRECT:
    case QUIZ_ANSWER_STATES.SKIPPED:
      return (
        <div className="button-1 quiz-button">
          <Icon name={icon} size="xs" />
        </div>
      );
    case QUIZ_ANSWER_STATES.LOCKED:
      return (
        <div className="button-1 quiz-button">
          <Icon name={icon} size="sm" />
        </div>
      );
    default:
      return null;
  }
}

export default QuizAnswerChoiceIcon;
